import React, {Component} from "react";
import "./PisaasInstanceContainerInfoPopUp.css"
import Authentication from "../../authentication/Authentication";
import Api from "../../api/Api";
import {toast} from "react-toastify";
import Whitelisting from "./Whitelisting"
import Tags from "./Tags"
import Restore from "./Restore";
import Upload from "./Upload"
import DuplicateService from "./DuplicateService"
import Sideload from "./Sideload";
import DashboardContainerDefinitionPanel from "./DashboardContainerDefinitionPanel";

export default class PisaasInstanceContainerInfoPopUp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedTab: "containerInfo",
            whitelistedUrls: [],
            requestingWhitelistedUrls: false,
            showEditUrls: false,
            tags: [],
            requestingTags: false,
            showEditTags: false,
            backups: [],
            requestingBackups: false,
            releases: [],
            requestingReleases: false,
            services: [],
            requestingServices: false
        };

        this.authentication = new Authentication();
    };

    componentDidMount() {
        this.load();
    }

    load = () => {
        this.setState({
            loading: true,
            requestingWhitelistedUrls: true,
            requestingTags: true,
            requestingReleases: true,
            requestingServices: true,
            requestingBackups: true
        });

        const api = new Api();


        if (this.authentication.isAdmin()) {
            api.fetchWhitelistedUrls(this.setWhitelistedUrls, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.pisaasInstance.domain);
        }

        if (this.authentication.isAdmin()) {
            api.pisaasListTags(this.setTags, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.pisaasInstance.pisaas_instance_id);
        }


        if (this.authentication.isAdmin()) {
            api.pisaasListBackupVersions(this.setBackups, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.pisaasInstance.domain, this.props.pisaasInstance.region);
        }

        if (this.authentication.isAdmin()) {
            api.pisaasListReleases(this.setReleases, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.pisaasInstance.domain, this.props.pisaasInstance.region);
        }

        if (this.authentication.isAdmin()) {
            api.fetchServiceInfoByInstance(this.setServiceInfo, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.pisaasInstance.domain, this.props.pisaasInstance.region);
        }
    };

    setReleases = async (releases) => {
        this.setState(
            {
                releases: releases,
                requestingReleases: false,
                loading: false
            });
    };

    setServiceInfo = async (services) => {
        this.setState(
            {
                services: services[0].services,
                requestingServices: false,
                loading: false
            });
    };

    setWhitelistedUrls = async (whitelistedUrls) => {
        this.setState(
            {
                whitelistedUrls: whitelistedUrls,
                requestingWhitelistedUrls: false,
                loading: false
            });
    };

    setBackups = async (backups) => {
        this.setState(
            {
                backups: backups,
                requestingBackups: false,
                loading: false
            });
    };


    setTags = async (tags) => {
        this.setState(
            {
                tags: tags,
                requestingTags: false,
                loading: false
            });
    };


    closePopUpOnOffClick = (e) => {
        const htmlTag = e.target;
        if (htmlTag.className === 'pisaas-popup-container') {
            this.props.togglePopUp()
        }
    }

    renderContainerInfo = (requesting) => {
        if (requesting) {
            return (
                <div className={"config-loading-container"}>
                    <h1 className={"loading-header"}>Requesting...</h1>
                    <div flex="" className="info-cell" layout="" vertical="">
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw instance-loading"/>
                    </div>
                </div>
            )
        } else {
            console.log("services", this.state.services)
            return (
                <div className={"container-info-table"}>
                    <h2 className={"config-header"} data-testid="config.header.containerInfo">Container Information</h2>

                    <table className={"container-info-table"} data-testid="config.containerInfo.table">
                        <thead>
                        <tr className={"container-info-row"} data-testid="config.containerInfo.table.headerRow">
                            <th className={"container-info-header"} data-testid="config.containerInfo.table.headerCell.service">Service</th>
                            <th className={"container-info-header"} data-testid="config.containerInfo.table.headerCell.desired">Desired</th>
                            <th className={"container-info-header"} data-testid="config.containerInfo.table.headerCell.pending">Pending</th>
                            <th className={"container-info-header"} data-testid="config.containerInfo.table.headerCell.running">Running</th>
                        </tr>
                        </thead>
                        {this.state.services.map((service) => {
                            const serviceName = service.serviceName.split('-')[0]
                            return (
                                <tbody key={service.serviceName}>
                                <tr className={"container-info-row"} data-testid="config.containerInfo.table.row">
                                    <td className={"container-info-header"} data-testid="config.containerInfo.table.cell.service">{serviceName.charAt(0).toUpperCase() + serviceName.slice(1)}</td>
                                    <td className={"container-info-header"} data-testid="config.containerInfo.table.cell.desiredCount">{service.desiredCount}</td>
                                    <td className={"container-info-header"} data-testid="config.containerInfo.table.cell.pendingCount">{service.pendingCount}</td>
                                    <td className={"container-info-header"} data-testid="config.containerInfo.table.cell.runningCount">{service.runningCount}</td>
                                </tr>
                                </tbody>
                            )
                        })}
                    </table>
                    <DashboardContainerDefinitionPanel serviceName={this.props.pisaasInstance.domain}
                                                       region={this.props.pisaasInstance.region}/>
                </div>
            )
        }
    }

    whitelistedUrlsRefresh = () => {
        const api = new Api();

        api.fetchWhitelistedUrls(this.setWhitelistedUrlsMaintainRequesting, function (err) {
            console.log(err);
            toast.error("Failed to refresh running instances", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }, this.props.pisaasInstance.domain);
    };

    backupsRefresh = () => {
        const api = new Api();

        api.pisaasListBackupVersions(this.setBackups, function (err) {
            console.log(err);
            toast.error("Failed to fetch Pisaas Instances", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }, this.props.pisaasInstance.domain, this.props.pisaasInstance.region);
    };

    setWhitelistedUrlsMaintainRequesting = (whitelistedUrls) => {
        this.setState({
            whitelistedUrls: whitelistedUrls,
            requestingWhitelistedUrls: false,
            loading: false
        });

    };

    updateSelectedTab = (e) => {
        this
            .setState({
                selectedTab: e.target.value
            })
    }

    toggleEditUrls = () => {
        this.setState({
            showEditUrls: !this.state.showEditUrls
        })
    }

    toggleEditTags = () => {
        this.setState({
            showEditTags: !this.state.showEditTags
        })
    }

    handleSubmit = (urls) => {
        const api = new Api();

        if (this.authentication.isAdmin()) {
            api.setWhitelistedUrls(this.whitelistedUrlsRefresh, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.pisaasInstance.domain, urls, this.props.pisaasInstance.pisaas_instance_id, this.props.pisaasInstance.region);
        }

        this.setState({
            requestingWhitelistedUrls: true,
            loading: true
        });

        this.toggleEditUrls()
    }

    handleTagSubmit = (tagsToAdd, tagsToDelete) => {
        const api = new Api();

        if (this.authentication.isAdmin()) {
            api.pisaasUpdateTags(this.tagsRefresh, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.pisaasInstance.pisaas_instance_id, tagsToAdd, tagsToDelete);
        }

        this.setState({
            requestingTags: true,
            loading: true
        });

        this.toggleEditTags()
    }

    tagsRefresh = () => {
        const api = new Api();

        if (this.authentication.isAdmin()) {
            api.pisaasListTags(this.setTags, function (err) {
                console.log(err);
                toast.error("Failed to fetch Pisaas Instances", {
                    position: toast.POSITION.BOTTOM_RIGHT
                });
            }, this.props.pisaasInstance.pisaas_instance_id);
        }
    }


    renderWhitelistInfo = (whitelistedUrls, requesting) => {
        if (requesting) {
            return (
                <div className={"config-loading-container"}>
                    <h1 className={"loading-header"}>Requesting...</h1>
                    <div flex="" className="info-cell" layout="" vertical="">
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw instance-loading"/>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={"container-info"}>
                    <Whitelisting handleSubmit={this.handleSubmit}
                                  whitelistedUrlsRefresh={this.whitelistedUrlsRefresh}
                                  toggleEditUrls={this.toggleEditUrls} showEditUrls={this.state.showEditUrls}
                                  whitelistedUrls={whitelistedUrls} requesting={requesting}/>
                </div>
            )
        }
    }

    renderTagInfo = (tags, requesting) => {
        if (requesting) {
            return (
                <div className={"config-loading-container"}>
                    <h1 className={"loading-header"}>Requesting...</h1>
                    <div flex="" className="info-cell" layout="" vertical="">
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw instance-loading"/>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={"container-info"}>
                    <Tags handleTagSubmit={this.handleTagSubmit} showEditTags={this.state.showEditTags}
                          requesting={requesting} tags={tags} toggleEditTags={this.toggleEditTags}/>
                </div>
            )
        }
    }

    renderRestoreInfo = (backups, requesting, domain, pisaasInstanceId, packageId, region) => {
        if (requesting) {
            return (
                <div className={"config-loading-container"}>
                    <h1 className={"loading-header"}>Requesting...</h1>
                    <div flex="" className="info-cell" layout="" vertical="">
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw instance-loading"/>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={"container-info"}>
                    <Restore backups={backups} requesting={requesting} domain={domain}
                             pisaasInstanceId={pisaasInstanceId} packageId={packageId} region={region}/>
                </div>
            )
        }
    }

    renderUploadInfo = (backups, requesting, domain, pisaasInstanceId, packageId, region) => {
        if (requesting) {
            return (
                <div className={"config-loading-container"}>
                    <h1 className={"loading-header"}>Requesting...</h1>
                    <div flex="" className="info-cell" layout="" vertical="">
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw instance-loading"/>
                    </div>
                </div>
            )
        } else {
            return (
                <div className={"container-info"}>
                    <Upload refresh={this.backupsRefresh} backups={backups} requesting={requesting} domain={domain}
                            pisaasInstanceId={pisaasInstanceId} packageId={packageId} region={region}/>
                </div>
            )
        }
    }


    renderDuplicateInfo = (domain, togglePopUp, originalEmail) => {
        return (
            <div className={"container-info"}>
                <DuplicateService domain={domain} togglePopUp={togglePopUp} orginalEmail={originalEmail}
                                  region={this.props.pisaasInstance.region}/>
            </div>
        )
    }

    renderSideloadInfo = (domain, togglePopUp) => {
        return (
            <div className={"container-info"}>
                <Sideload domain={domain} togglePopUp={togglePopUp} region={this.props.pisaasInstance.region}/>
            </div>
        )
    }

    render() {
        return (
            <div className={"pisaas-config-popup-container"} data-testid="admin.config.popUp" onClick={(e) => this.closePopUpOnOffClick(e)}>
                <div className={"config-box"}>
                    <div className={"top-bar"} data-testid="admin.config.popUp.topBar">
                        <i className={"try-pi-btn fa fa-bars config-menu-button"}/>
                                                <button className="try-pi-btn config-close-button"
                                                        data-testid="admin.config.popUp.topBar.button.close"
                                onClick={() => this.props.togglePopUp()}>X
                        </button>
                    </div>
                    <div className={"info-container"}>
                        <div className={"side-nav"} data-testid="sideNav">
                            <button value={"containerInfo"}  data-testid="sideNav.button.containerInfo" onClick={(e) => this.updateSelectedTab(e)}>Container
                                Information
                            </button>
                            {this.authentication.isAdmin() && this.props.pisaasInstance.package_id !== 8 ?
                                <button value={"whitelist"}  data-testid="sideNav.button.whitelisting"
                                        onClick={(e) => this.updateSelectedTab(e)}>Whitelisting</button> : <></>}
                            {this.authentication.isAdmin() && this.props.pisaasInstance.package_id !== 8 ?
                                <button value={"tags"} data-testid="sideNav.button.tags"
                                        onClick={(e) => this.updateSelectedTab(e)}>Tags</button> : <></>}
                            {this.authentication.isAdmin() && this.props.pisaasInstance.package_id !== 8 ?
                                <button value={"restore"}  data-testid="sideNav.button.restore" onClick={(e) => this.updateSelectedTab(e)}>Restore From
                                    Backups</button> : <></>}
                            {this.authentication.isAdmin() && this.props.pisaasInstance.package_id !== 8 ?
                                <button value={"upload"}  data-testid="sideNav.button.upload" onClick={(e) => this.updateSelectedTab(e)}>Upload
                                    Repo</button> : <></>}
                            {this.authentication.isAdmin() && this.props.pisaasInstance.package_id !== 8 ?
                                <button value={"duplicate"} data-testid="sideNav.button.duplicate"
                                        onClick={(e) => this.updateSelectedTab(e)}>Duplicate</button> : <></>}
                            {this.authentication.isAdmin() && this.props.pisaasInstance.package_id !== 8 ?
                                <button value={"sideload"} data-testid="sideNav.button.sideload"
                                        onClick={(e) => this.updateSelectedTab(e)}>Sideload</button> : <></>}
                        </div>
                        {this.state.selectedTab === "containerInfo" ? this.renderContainerInfo(this.state.requestingServices) : <></>}
                        {this.state.selectedTab === "whitelist" ? this.renderWhitelistInfo(this.state.whitelistedUrls, this.state.requestingWhitelistedUrls) : <></>}
                        {this.state.selectedTab === "tags" ? this.renderTagInfo(this.state.tags, this.state.requestingTags) : <></>}
                        {this.state.selectedTab === "restore" ? this.renderRestoreInfo(this.state.backups, this.state.requestingBackups, this.props.pisaasInstance.domain, this.props.pisaasInstance.pisaas_instance_id, this.props.pisaasInstance.package_id, this.props.pisaasInstance.region) : <></>}
                        {this.state.selectedTab === "upload" ? this.renderUploadInfo(this.state.backups, this.state.requestingBackups, this.props.pisaasInstance.domain, this.props.pisaasInstance.pisaas_instance_id, this.props.pisaasInstance.package_id, this.props.pisaasInstance.region) : <></>}
                        {this.state.selectedTab === "duplicate" ? this.renderDuplicateInfo(this.props.pisaasInstance.domain, this.props.togglePopUp, this.props.pisaasInstance.email) : <></>}
                        {this.state.selectedTab === "sideload" ? this.renderSideloadInfo(this.props.pisaasInstance.domain, this.props.togglePopUp) : <></>}
                    </div>
                </div>
            </div>
        )
    }
}



